import React from 'react';
import OpenQuestion from './QuestionsTypes/OpenQuestion';
import DateQuestion from './QuestionsTypes/DateQuestion';
import { GetQuestionsConfiguration } from './Configuration/QuestionConfiguration';
import TinyLoader from '../../Components/Loader/TinyLoader';
import Parse from 'parse';
import {Admin} from './../../../configurations/Admin';
const moment = require('moment');



class PickupOrder extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      questions: GetQuestionsConfiguration(),
      patient: props.patient,
      loading:false,
      isError:false,
      pickUpPlace:"",
      receptionDate:"",
      receptionTime:"",
      pickUpPlaceErrors:[],
      receptionDateErrors:[],
      receptionTimeErrors:[]
    }
  }

  countErrorsAndValidateFields = async () => {
    let errorsCounter = 0;
    let {questions} = this.state;
    const {pickUpPlace,receptionDate,receptionTime} = this.state;
    this.setState({
      pickUpPlaceErrors:[],
      receptionDateErrors:[],
      receptionTimeErrors:[]
    });
    if(pickUpPlace === null || pickUpPlace === ""){
      this.setState({pickUpPlaceErrors: ["Debes especificar la dirección"]})
      errorsCounter += 1;
    }

    if(receptionDate === null || receptionDate === ""){
      this.setState({receptionDateErrors: ["Debes especificar la fecha"]})
      errorsCounter += 1;
    }

    if(receptionTime === null || receptionTime === ""){
      this.setState({receptionTimeErrors: ["Debes especificar la hora"]})
      errorsCounter += 1;
    }

    var reception = moment(receptionDate);
    if(reception < moment()){
      this.setState({receptionDateErrors: ["La fecha debe ser mayor a la fecha de hoy"]})
      errorsCounter += 1;
    }

    return errorsCounter;
  }


  onSave = async () => {
    let currentUser = Parse.User.current();
    if(currentUser.get("username") === Admin.user_admin){
      this.setState({isError:true});
      return;
    }


    const {pickUpPlace, receptionDate, receptionTime} = this.state;
    console.log(this.state);

    let errorsCounter = await this.countErrorsAndValidateFields();
    if(errorsCounter > 0){
      this.setState({isError:true});
      return;
    }
    this.setState({isError:false});
    const {patient} = this.props;
    const Patient = Parse.Object.extend('Patient');
    const query = new Parse.Query(Patient);
    let patientFounded = await query.get(patient.id);
    patientFounded.set("pickUpPlace", pickUpPlace);
    patientFounded.set("receptionDate", receptionDate);
    patientFounded.set("receptionTime", receptionTime);

    this.setState({loading:true});
    await patientFounded.save();
    this.setState({loading:false});

  }

  handleChangeListener = (field, value) => {
    if(field==="pickUpPlace") {this.setState({pickUpPlace:value})};
    if(field==="receptionDate") {this.setState({receptionDate:value})};
    if(field==="receptionTime") {this.setState({receptionTime:value})};
  }

  
  updateQuestionsWithPatientData = (patient) => {
    let currentUser = Parse.User.current();
    
    
    if(patient === null || patient.id === 0){
      return;
    }
    this.setState({
      pickUpPlace: currentUser.get("address"), 
      receptionDate:patient.get("receptionDate"), 
      receptionTime:patient.get("receptionTime"), 
    });
  }
  
  componentDidMount = () => {
    this.updateQuestionsWithPatientData(this.props.patient);
    this.setState({patient: this.props.patient});
  }


  render() {
    
    const {patient} = this.state;
    const {pickUpPlace, receptionDate, receptionTime} = this.state;
    console.log(this.state, "on render")
    if(patient === null){
      return <p>Usuario inválido</p>
    }else{
      if(!patient){
        return <p>cargando...</p>
      }
    }

    const loading = this.state.loading ? <TinyLoader/> : null;

    let errorOnForm = null;
    if(this.state.isError){
      errorOnForm = <p className="error text-center">Existen algunos errores en el formulario</p>
    }

    const {pickUpPlaceErrors, receptionDateErrors, receptionTimeErrors} = this.state;

    return(
      <div>
        <div>
          <div className="vertical-separator-20px"></div> 

          <h3>ORDEN PARA RECOGER MUESTRAS </h3>

          <span className="error">*Todos los campos son obligatorios</span> 
          <p>Recogeremos la muestra en: <b> {pickUpPlace}</b> el: <b> {receptionDate}</b> a las: <b> {receptionTime}</b></p>
          <div className="vertical-separator-10px"></div>

          <OpenQuestion
            field={this.state.questions["pickUpPlace"].field}
            text={this.state.questions["pickUpPlace"].text}
            predefinedValue={pickUpPlace}
            // placeHolder={this.state.questions["pickUpPlace"].placeHolder}
            // rules={this.state.questions["pickUpPlace"].rules}
            // type={this.state.questions["pickUpPlace"].type}
            value={pickUpPlace}
            // otherValue={this.state.questions["pickUpPlace"].otherValue}
            isError={pickUpPlaceErrors.length > 0}
            errors={pickUpPlaceErrors}
            handleChangeListener={this.handleChangeListener}
          />

          <div className="vertical-separator-10px"></div> 

          <div className="row">
            <div className="col-md-6">
              <DateQuestion
                field={this.state.questions["receptionDate"].field}
                text={this.state.questions["receptionDate"].text}
                note={this.state.questions["receptionDate"].note}
                options={this.state.questions["receptionDate"].options}
                predefinedValue={receptionDate}
                predefinedOtherValue={this.state.questions["receptionDate"].predefinedOtherValue}
                placeHolder={this.state.questions["receptionDate"].placeHolder}
                rules={this.state.questions["receptionDate"].rules}
                type={this.state.questions["receptionDate"].type}
                value={receptionDate}
                otherValue={this.state.questions["receptionDate"].otherValue}
                isError={receptionDateErrors.length > 0}
                errors={receptionDateErrors}
                handleChangeListener={this.handleChangeListener}
              />
            </div>
            <div className="col-md-6">
              <OpenQuestion
                field={this.state.questions["receptionTime"].field}
                text={this.state.questions["receptionTime"].text}
                note={this.state.questions["receptionTime"].note}
                options={this.state.questions["receptionTime"].options}
                predefinedValue={receptionTime}
                predefinedOtherValue={this.state.questions["receptionTime"].predefinedOtherValue}
                placeHolder={this.state.questions["receptionTime"].placeHolder}
                rules={this.state.questions["receptionTime"].rules}
                type={this.state.questions["receptionTime"].type}
                value={receptionTime}
                otherValue={this.state.questions["receptionTime"].otherValue}
                isError={receptionTimeErrors.length > 0}
                errors={receptionTimeErrors}
                handleChangeListener={this.handleChangeListener}
              />
            </div>
          </div>
          

        <div className="vertical-separator-10px"></div> 

        <div className="row justify-content-center">
          <div className="col-md-4 col-md-offset-4">
            {errorOnForm}
            <button
              className="button-outlined"
              onClick={this.onSave}
              >
              Guardar
            </button>
          </div>
          <div className="col-md-1">
            <div className="vertical-separator-10px"></div> 
            {loading}
          </div> 
        </div>

        <div className="vertical-separator-30px"></div> 

      </div>
    </div>

    );
  }
}

export default PickupOrder;



// WEBPACK FOOTER //
// ./src/views/Forms/Patient/PickupOrder.js